export default __webpack_public_path__ + "static/app-landing-page-3-c9a7e29935555a0a705911da240befe8.png";